// extracted by mini-css-extract-plugin
export default {"heading":"Chapter_heading__5DaMr","content":"Chapter_content__q+8jG"};